import { PdfTemplate } from "components";
import { ItemType } from "../utils";
import { RowExportTypePdf } from "types";
import { convertNumber } from "utils";
import moment from "moment";

export function ExportPdf(props: {
    data: ItemType[]
    filter: {
        account_number: boolean,
        sub_header: boolean,
        zero_value: boolean,
        date: string
    }
}) {
    const dataMap: RowExportTypePdf[] = sortByHierarchy(props.data).filter((item: any) => {
        return (
            (props.filter.sub_header || item.header_level !== 2) &&
            (props.filter.zero_value || item.opening_balance !== 0)
        )
    }).map((item: any) => {
        const textBold = item.header_level !== 3 ? 'bold' : 'normal';

        return {
            account: {
                text: props.filter.account_number ? item.coacode : '',
                style: { fontWeight: textBold }
            },
            name: {
                text: item.coa_name,
                style: { fontWeight: textBold }
            },
            opening_balance: {
                text: convertNumber(item.opening_balance)?.intoCurrency,
                style: { textAlign: 'right', fontWeight: textBold }
            }
        }
    })

    return (
        <PdfTemplate
            data={dataMap}
            title="OPENING BALANCE"
            column={[
                { header: 'ACCOUNT', key: 'account', width: 20 },
                { header: 'NAME', key: 'name', width: 50 },
                { header: 'OPENING BALANCE', key: 'opening_balance', width: 35, textAlign: 'right' },
            ]}
            date={moment(props.filter.date).format('DD-MM-YYYY')}
        />
    )
}

function sortByHierarchy(dataList: any, parentId = -1) {
    const parentItems = dataList.filter((item: any) => item.parent_id === parentId);
    parentItems.sort((a: any, b: any) => a.coacode.localeCompare(b.coacode));

    return parentItems.flatMap((parent: any) => {
        return [parent, ...sortByHierarchy(dataList, parent.coa_id)];
    });
}